import React from 'react';
import { Link } from 'react-router';
import { API_URL } from 'constants/config';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { CheckPermission } from 'modules/login/CheckPermission';
import { RowItemDanhSachKeHoachThanhTra } from 'modules/thanh-tra/datatable';
import { DatePicker, Input, DropDown } from 'components/tt-forms/common';
import { ThanhTra, Danhmuc } from 'api';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import moment from 'moment';
import { get, isEmpty } from 'lodash';
import { downloadFile } from "constants/downloadFile";
import './style.scss';

class DanhSachKeHoachThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isKHTTchecked: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      namThanhTra: '',
      nguoiKy: '',
      donViIds: [],
      donViChuTriList: [],
      donViSelected: [],
      loading: false,
      thanhTraQuanHuyenId: '',
      showDropdownCreate: false,
      loaiHinhThanhTraList: [
        {
            giaTri: "THANH_TRA",
            ten: "Thanh tra"
        },
        {
            giaTri: "KIEM_TRA",
            ten: "Kiểm tra"
        }
      ]
    }
  }

  async componentDidMount() {
    let data = localStorage.getItem('khttData') ? JSON.parse(localStorage.getItem('khttData')) : {};
    this.getDonViChuTri(data.donViSelected);
    await this.checkNamThanhTraXuLy();
    await this.setState({
      pageData: {
        number: data.page || 0,
        size: data.size || 10,
        soQuyetDinh: data.soQuyetDinh || '',
        nguoiKy: data.nguoiKy || '',
        namThanhTra: this.props.goBack ? data.namThanhTra : this.state.namThanhTra,
        donViSelected: data.donViSelected || [],
        tuNgay: '',
        denNgay: ''
      }
    })
    this.kiemTraTonTaiKHTTTrongNamThanhTra();
    this.getKeHoachThanhTraList();
    this.checkDonVi();
    this.getNamThanhTraList();
    this.checkDonViQuanHuyen();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.namThanhTra !== prevProps.namThanhTra) {
      this.forceUpdate();
    }

  }

  checkDonVi() {
    Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
      }
    });
  }

  checkDonViQuanHuyen() {
    Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CCQQL_UBND_QUAN_HUYEN' }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ thanhTraQuanHuyenId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
      }
    });
  }

  getDonViChuTri(selectedItem) {
    ThanhTra.actions.getDonViKHTT.request().then(res => {
      if (!this.refs.dskhtt) {
        return;
      }
      if (res.data && res.data._embedded) {
        this.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
        this.state.donViSelected = selectedItem || [];
      } else {
        this.state.donViChuTriList = [];
      }
      this.setState({ ...this.state });
    });
  }

  checkDate(stD, endD) {
    let startDate = moment(stD, 'MM/DD/YYYY').valueOf();
    let endDate = moment(endD, 'MM/DD/YYYY').valueOf();
    if (startDate > endDate) {
      Toastr('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
    }
  }

  async getKeHoachThanhTraList(isFirst, e) {
    let state = this.state;
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }
    if (this.validateSubmitForm()) {
      if (isFirst) {
        state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      let params = {
        page: state.pageData.number,
        size: state.pageData.size,
        sort: 'namThanhTra,desc',
        isTatCaDonVi: false
      }
      if (this.state.loaiKeHoach) {
        params.loaiKeHoach = this.state.loaiKeHoach;
      }
      if (this.state.namThanhTra) {
        params.namThanhTra = this.state.namThanhTra;
      }
      if (state.donViSelected.length) {
        let idArr = [];
        state.donViSelected.map(item => {
          idArr.push(item.value);
        });
        params.donViIds = idArr.join();
      }
      if (state.soQuyetDinh) {
        params.soQuyetDinh = state.soQuyetDinh;
      }
      if (!isEmpty(state.namThanhTra)) {
        params.namThanhTra = state.namThanhTra;
      }
      if (state.tuNgay) {
        params.tuNgay = moment(state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (state.denNgay) {
        params.denNgay = moment(state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (state.tuNgay && state.denNgay && isFirst === true) {
        this.checkDate(state.tuNgay, state.denNgay);
      }
      if (state.nguoiKy) {
        params.nguoiKy = state.nguoiKy;
      }
      state.loading = true;
      await this.setState({ loading: true });
      await localStorage.setItem('khttData', JSON.stringify({ ...params, donViSelected: state.donViSelected }));
      await ThanhTra.actions.getKeHoachThanhTra.request(null, params).then(res => {
        if (!this.refs.dskhtt) {
          return;
        }
        if (res.data._embedded) {
          const data = get(res, 'data._embedded.medial_KeHoachThanhTra_DanhSaches');
          state = {
            ...state,
            data,
            pageData: res.data.page,
            tableLoading: false,
            loading: false
          };
        } else {
          state = {
            ...state,
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            loading: false
          };
        }
      });
    }
    this.setState(state);
    this.props.dispatch({ type: 'DSTT_RESET_GO_BACK' });
  }

  onChange(name, e) {
    if (name == 'DonVi') {
      this.setState({
        donViSelected: e
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getKeHoachThanhTraList();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getKeHoachThanhTraList();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleDelete(sID) {
    ThanhTra.actions.deleteKeHoachThanhTra.request({ id: sID }).then(res => {
      Toastr(msg.removeKHSuccess, 'success');
      this.getKeHoachThanhTraList();
    });
  }

  getNamThanhTraList() {
    if (this.props.namThanhTra.length === 0) {
      ThanhTra.actions.getNamThanhTra.request().then(res => {
        if (res && res.data) {
          this.props.dispatch({ type: 'SET_NAM_THANH_TRA', data: res.data })
        }
      });
    }
  }

  kiemTraTonTaiKHTTTrongNamThanhTra() {
    ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          isKHTTchecked: !!get(res, 'data.isHienThiButtonThemMoiKHTT')
        });
      }
    });
  }

  async checkNamThanhTraXuLy() {
    await ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(async res => {
      if (!isEmpty(res.data)) {
        await this.setState({
          namThanhTra: get(res, 'data.namThanhTra')
        });
      }
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  handleExport() {
    if (this.state.donViSelected.length) {
      let idArr = [];
      this.state.donViSelected.map(item => {
        idArr.push(item.value);
      });
      this.state.donViIds = idArr.join();
    }
    let URL = String(API_URL) + "/danhMucCuocThanhTras/xuatExcel?soQuyetDinh=" + this.state.soQuyetDinh
      + "&tuNgay=" + (this.state.tuNgay ? moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&denNgay=" + (this.state.denNgay ? moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '')
      + "&nguoiKy=" + (this.state.nguoiKy ? this.state.nguoiKy : '')
      + "&donViIds=" + (this.state.donViIds ? this.state.donViIds : [])
      + "&loaiKeHoach=" + (this.state.loaiKeHoach ? this.state.loaiKeHoach : '');
    downloadFile(URL);
  }

  toggleDropdownCreate() {
    this.setState({
      ...this.state,
      showDropdownCreate: !this.state.showDropdownCreate
    })
  }

  render() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    return (
      <div className="center reception-container" ref="dskhtt">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách kế hoạch thanh tra, kiểm tra</p>
          </div>
          <div className="right-content dropdown-create-wrap">
            <ShowIf condition={CheckPermission('THANHTRA_THEM')}>
              <Link className="btn-green btn-dropdown" onClick={this.toggleDropdownCreate.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              {
                this.state.showDropdownCreate && (
                  <div className='dropdown-create'>
                    <Link className="dropdown-item" to='/thanh-tra/them-moi-ke-hoach-thanh-tra'>Kế hoạch thanh tra</Link>
                    <Link className="dropdown-item" to='/thanh-tra/them-moi-ke-hoach-kiem-tra'>Kế hoạch kiểm tra</Link>
                  </div>
                )
              }
            </ShowIf>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <form onSubmit={this.getKeHoachThanhTraList.bind(this, true)}>
              <div className='row pl10 pr10'>
                <div className='col-83 no-gutter'>
                  <Input className='col-25' label="Số quyết định phê duyệt KHTT/KHKT" placeholder="Nhập số quyết định" value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' maxLength={255}/>
                  <DatePicker className="col-20" label="Quyết định ra từ ngày" bindValidator={this} channel="formTaoDon" endDate={this.state.denNgay} onChange={this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
                  <DatePicker className="col-20" label="Đến ngày" bindValidator={this} channel="formTaoDon" startDate={this.state.tuNgay} onChange={this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
                  <DropDown className='col-25 mb18' label="Năm thanh tra/kiểm tra" options={this.props.namThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder />
                  <DropDown label="Loại hình thanh tra/kiểm tra" selectedValue={this.state.loaiKeHoach} placeholder className="col-25" onChange={this.handleChange.bind(this, 'loaiKeHoach')} name='loaiKeHoach'
                    options={this.state.loaiHinhThanhTraList} keyName="giaTri" valueName="ten"/>
                </div>
                <div className='col-16 mb0-18 search-thanh-tra'>
                  <button className={`btn-green ${this.state.loading ? 'btn-loading-inline' : ''}`} >
                    <i className='tt-search'></i>Tìm kiếm
                  </button>
                </div>
              </div>
            </form>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={header.thanhTra.DSKHTT}
            handleExport={this.handleExport.bind(this)}
            dataList={this.state.data}
            exporttext="Xuất Excel"
            thanhTra
            hideButtonExport={true}
            pageData={this.state.pageData}
            parent={this}
            search={true}
            tableLoading={this.state.tableLoading}>
            <RowItemDanhSachKeHoachThanhTra isTTTP={userInfo.donViId == this.state.thanhTraThanhPhoId} />
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachKeHoachThanhTra.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
}

const mapStateToProps = function (state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  }
}

export default connect(mapStateToProps)(DanhSachKeHoachThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/DanhSachKeHoachThanhTra.jsx